// extracted by mini-css-extract-plugin
module.exports = {"center":"Professors_center__3VRdp"};